module.exports = __webpack_public_path__ + "1053d30ab8af86f92cf6026adbdd18f0.svg";